import { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import moment from "moment";
import { fetchBitacora } from "../Api/fetchBitacora";
import { Carousel } from "react-responsive-carousel";
import { UseUser, UseAdmin, UseAuth } from "../hooks";
import { fetchAdmin } from "../Api/fetchAdmin";
import { VERSION_APP } from "../utilities";
import { LoadingSpinner } from "../components/LoadingSpinner";
import "../theme/Carrucel.css";

export const CarrucelBanner = () => {
  const [currentIndex, setCurrentIndex] = useState();
  const [isLoading, setLoading] = useState(true);
  const [banners, setBanners] = useState([]);
  const { company, ceco, jobTitle, employeeId, mail, device } = UseUser();
  const { AdminIn, brandfiMarcaId, branchFiSucursalId, branchFiPaisId } = UseAdmin();
  const { uniqueId } = UseAuth();

  function handleChange(index) {
    setCurrentIndex(index);
  }
  useEffect(() => {
    getDataBanner();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, ceco, jobTitle]);

  const getDataBanner = async () => {
    if (!company || !ceco || !jobTitle) return;

    const onFailure = ({ error, config }) => {
      getBitacora(error, config);
      setLoading(false);
    };

    const onSuccess = async ({ data, config }) => {
      setBanners(data.body.banners);

      try {
        await AdminIn(
          data.body.brand.FCNOMBRE.toString(),
          data.body.brand.FIMARCAID.toString(),
          data.body.brand.FIBIID.toString(),
          data.body.brand.FIESTATUSID.toString(),
          data.body.branch.FCNOMBRE.toString(),
          data.body.branch.FISUCURSALID.toString(),
          data.body.branch.FIPAISID.toString(),
          data.body.rol.FIROLID.toString()
        );
      } catch (error) {
        /* eslint-disable no-console */
        console.error("Error al guardar datos", error);
      }

      if (data.statusCode === 500) {
        alert("Mensaje: " + JSON.stringify(data.body.mensaje));
      }

      setLoading(false);
      getBitacora(data, config);
    };

    fetchAdmin(company, ceco, jobTitle).then(onSuccess).catch(onFailure);
  };

  const getBitacora = async (data, config) => {
    //console.log("entro a bitacora");
    const deviceWeb = `${uniqueId}-${device}`;
    const key = `${uniqueId}-${device}-${employeeId}`;
    const obtenerFechaEnFormato = () => {
      const ahora = moment();
      const fechaEnFormato = ahora.format("YY/MM/DD HH:mm:ss.SSS");
      return fechaEnFormato;
    };
    const fechaActualEnFormato = obtenerFechaEnFormato();

    if (brandfiMarcaId != null && config != null && data != null) {
      const onFailure = (error) => {
        //console.log("bitacora-admin-error", error);
      };

      const onSuccess = ({ data }) => {};

      fetchBitacora(
        mail,
        deviceWeb,
        fechaActualEnFormato,
        key,
        config,
        data,
        "Admin",
        VERSION_APP,
        employeeId,
        brandfiMarcaId,
        branchFiSucursalId,
        branchFiPaisId
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  const renderSlides = banners.map((banner) => (
    <div className="carousel-slide" key={banner.FIBANNERID}>
      <div className="carousel-image-container">
        <img
          className="carousel-image"
          src={`${banner.FCURLS3}?${new Date().getTime()}`}
          alt={banner.FCTITULO || "Banner"}
        />
      </div>
      <div className="carousel-content">
        <h3 className="carousel-title">{banner.FCTITULO}</h3>
        <p className="carousel-description">{banner.FCDESCRIPCION}</p>
        {banner.FCLINKEXTERNO && (
          <a
            href={banner.FCLINKEXTERNO}
            target="_blank"
            rel="noopener noreferrer"
            className="carousel-link"
          >
            Ver más →
          </a>
        )}
      </div>
    </div>
  ));

  if (isLoading) {
    return (
      <div className="carousel-loading">
        <LoadingSpinner />
      </div>
    );
  }

  if (!banners || banners.length === 0) {
    return (
      <div className="carousel-empty">
        <p>No hay banners disponibles</p>
      </div>
    );
  }

  return (
    <div className="carousel-wrapper">
      <Carousel
        showIndicators={true}
        showThumbs={false}
        showArrows={true}
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        selectedItem={currentIndex}
        onChange={handleChange}
        showStatus={false}
        swipeable={true}
        emulateTouch={true}
      >
        {renderSlides}
      </Carousel>
    </div>
  );
};
